import { useGT } from 'gt-react';
import { splitCommentBody, type CommentBodySegment } from '@erp/shared-utils';

/** Keys each segment by its offset in the body, which is stable per body. */
function keyedSegments(
  body: string,
): { key: string; segment: CommentBodySegment }[] {
  const keyed: { key: string; segment: CommentBodySegment }[] = [];
  let offset = 0;
  for (const segment of splitCommentBody(body)) {
    keyed.push({ key: `${segment.kind}-${offset}`, segment });
    offset += segment.kind === 'text' ? segment.text.length : 1;
  }
  return keyed;
}

/**
 * A comment body with `{user:<uuid>}` tokens drawn as `@Name`. Names resolve
 * at render time, so a renamed user reads correctly on old notes.
 */
export function CommentBody({
  body,
  userNameById,
}: {
  body: string;
  userNameById?: Map<string, string>;
}) {
  const gt = useGT();

  return (
    <>
      {keyedSegments(body).map(({ key, segment }) =>
        segment.kind === 'text' ? (
          <span key={key}>{segment.text}</span>
        ) : (
          <span
            key={key}
            className="font-medium text-blue-700"
            data-testid="comment-mention"
          >
            @
            {userNameById?.get(segment.userId) ??
              gt('Unknown user', {
                context:
                  'shown in a note for an @mention whose user cannot be found',
              })}
          </span>
        ),
      )}
    </>
  );
}
